import { getTenant } from '../utils/getTenant';

const apiSegment = 'api';
const apiVersion = 'v1';
const { protocol } = window.location;
const hostname = getTenant();
const rootUrl = `${protocol}//${hostname}`;
const baseApiUrl = `${rootUrl}/${apiSegment}/${apiVersion}`;
const baseAgentsUrl = `${baseApiUrl}/agents`;
const basePropertiesUrl = `${baseApiUrl}/properties`;
const baseThemesUrl = `${baseApiUrl}/themes`;
const baseValuationsUrl = `${baseApiUrl}/valuations`;

const apiUrls = {
	agent: `${baseAgentsUrl}`,
	properties: `${basePropertiesUrl}`,
	themes: `${baseThemesUrl}`,
	valuation: {
		contact: `${baseValuationsUrl}/:agentId/contact`,
		request: `${baseValuationsUrl}/:agentId/request`,
	},
};

export default apiUrls;
